import { Type } from "class-transformer"

export class ReplicationMetaDTO {
  @Type(() => Date)
  timestamp!: Date
}
